import Notification from '../../../../entities/notification/Notification'
import NotificationsActionTypes  from './NotificationsActionTypes'

export interface CloseNotification {
  type: NotificationsActionTypes.CLOSE_NOTIFICATION
  payload: {
    id: string
  }
}

export function closeNotification(id: string): CloseNotification {
  return {
    type: NotificationsActionTypes.CLOSE_NOTIFICATION,
    payload: {
      id,
    },
  }
}

export interface SetNotification {
  type: NotificationsActionTypes.SET_NOTIFICATION
  payload: {
    notification: Notification
  }
}

export function setNotification(notification: Notification): SetNotification {
  return {
    type: NotificationsActionTypes.SET_NOTIFICATION,
    payload: {
      notification,
    },
  }
}
